/**
 * 工單 create／update 寫入 payload。
 * 禁止：workOrderNo、status、quantity 唯讀欄、嵌套 mtr／bom／selectedMtr。
 * Create／Update 都不送 scrapQty／cancelQty（PROCESSING 後走異動單）。
 * PROCESSING update 僅 scheduledStartDate＋updatedAt。
 * Wire：`bomMtrSelections`（`sourceGroupMtrId`／`selectedMtrId`）。
 * 費用：`expenses` 為已轉好的 `{id?,name,amount}[]`；省略＝BE 不讀不改。
 * DRAFT PATCH 帶 `expenses` 時必帶 `expensesRevision`（detail 回傳）。
 */
export function buildWorkOrderCreatePayload(values) {
  return buildWorkOrderWritePayload(values);
}

export function buildWorkOrderUpdatePayload(values) {
  const updatedAt = values?.updatedAt ?? values?.record?.updatedAt ?? null;
  if (values?.status === 'PROCESSING') {
    const payload = {
      scheduledStartDate: values?.scheduledStartDate,
    };
    if (updatedAt != null && updatedAt !== '') {
      payload.updatedAt = updatedAt;
    }
    return payload;
  }

  return buildWorkOrderWritePayload(values, { updatedAt });
}

function buildWorkOrderWritePayload(values, { updatedAt = null } = {}) {
  const payload = {
    scheduledStartDate: values?.scheduledStartDate,
    mtrId: values?.mtrId,
    processingFactoryId: values?.processingFactoryId ?? null,
    workWarehouseId: values?.workWarehouseId,
    targetWarehouseId: values?.targetWarehouseId,
    manufacturingQty: values?.manufacturingQty,
    bomMtrSelections: mapBomMtrSelections(values?.bomMaterialSelections),
    issueReason: values?.issueReason ?? null,
    remark: values?.remark ?? null,
  };

  if (Array.isArray(values?.expenses)) {
    payload.expenses = values.expenses;
    if (values?.expensesRevision != null) {
      payload.expensesRevision = values.expensesRevision;
    }
  }

  if (updatedAt != null && updatedAt !== '') {
    payload.updatedAt = updatedAt;
  }

  return payload;
}

function mapBomMtrSelections(rows = []) {
  return (rows ?? []).map((row) => ({
    sourceGroupMtrId: row?.sourceGroupMaterialId ?? row?.sourceGroupMtrId,
    selectedMtrId: row?.selectedMaterialId ?? row?.selectedMtrId,
  }));
}
